module.exports = __webpack_public_path__ + "media/assets/marker-icon-2b3e1faf.png";